import React from 'react';
import { Grid } from '@material-ui/core';
import { RTLAboutCard } from '../../cards/AboutCard';
import { RTLLinksCard } from '../../cards/LinksCard';
import { WarningCard } from '../../cards/WarningCard';
import {
  RELATION_CONSUMES_API,
  RELATION_DEPENDENCY_OF,
  RELATION_DEPENDS_ON,
  RELATION_HAS_PART,
  RELATION_PART_OF,
  RELATION_PROVIDES_API,
} from '@backstage/catalog-model';
import { RTLCatalogGraphCard } from '../../cards/CatalogGraphCard';
import {
  RELATION_DEPLOYED_IN,
  RELATION_HOSTS,
} from '@internal/backstage-plugin-catalog-backend-module-rtl/src/processors/realtions';

export const OverviewContent = () => {
  return (
    <Grid container spacing={3} alignItems="stretch">
      <WarningCard />
      <Grid item md={6} sm={12}>
        <RTLAboutCard />
      </Grid>
      <Grid item md={6} sm={12}>
        <RTLCatalogGraphCard
          height={400}
          relations={[
            RELATION_PART_OF,
            RELATION_DEPENDS_ON,
            RELATION_DEPENDENCY_OF,
            RELATION_HAS_PART,
            RELATION_PROVIDES_API,
            RELATION_CONSUMES_API,
            RELATION_DEPLOYED_IN,
            RELATION_HOSTS,
          ]}
        />
      </Grid>
      <RTLLinksCard />
    </Grid>
  );
};
